import { render, staticRenderFns } from "./ModalConectAuth2F.vue?vue&type=template&id=0c0ff034&scoped=true&"
import script from "./ModalConectAuth2F.vue?vue&type=script&lang=js&"
export * from "./ModalConectAuth2F.vue?vue&type=script&lang=js&"
import style0 from "./ModalConectAuth2F.vue?vue&type=style&index=0&id=0c0ff034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ff034",
  null
  
)

export default component.exports